import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
    },
    colorContainer: {
        width: FOUNDATIONS.size_200,
        height: FOUNDATIONS.size_150,
        border_radius: FOUNDATIONS.radius_200,
        background_color: FOUNDATIONS.color_chart_bg_100,
    },
    containerTitle: {
        display: 'flex',
        flex_direction: 'row',
        gap: FOUNDATIONS.spacing_150,
        align_items: 'center',
    },
    containerValues: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
    },
    firstValue: {
        font_variant: TextVariantType.FONT_PARAGRAPH_100,
        font_weight: FONT_WEIGHT.font_weight_600,
        color: FOUNDATIONS.color_comp_datavisualization_charlegend_font,
    },
    secondValue: {
        font_variant: TextVariantType.FONT_PARAGRAPH_100,
        font_weight: FONT_WEIGHT.font_weight_600,
        color: FOUNDATIONS.color_comp_datavisualization_charlegend_font,
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_datavisualization_charlegend_font,
    },
});
//# sourceMappingURL=commonStyles.js.map